export default __webpack_public_path__ + "static/media/Desktop.77734e78.png";